import { render, staticRenderFns } from "./SummaryItemActionsList.vue?vue&type=template&id=1f947b03&"
import script from "./SummaryItemActionsList.vue?vue&type=script&lang=js&"
export * from "./SummaryItemActionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports